import { BottomTabStateToken, IconTokens, IconSizeTokens, IconAlignmentTokens, } from '@voltmoney/schema';
export const args = {
    data: [
        {
            id: '1',
            title: 'My Account',
            status: BottomTabStateToken.SELECTED,
            icon: {
                name: IconTokens.Chart,
                size: IconSizeTokens.XL,
                align: IconAlignmentTokens.left,
            },
        },
        {
            id: '2',
            title: 'Transaction',
            status: BottomTabStateToken.NOT_SELECTED,
            icon: {
                name: IconTokens.RuppeFile,
                size: IconSizeTokens.XL,
                align: IconAlignmentTokens.left,
            },
        },
        {
            id: '3',
            title: 'Protfolio',
            status: BottomTabStateToken.NOT_SELECTED,
            icon: {
                name: IconTokens.Square,
                size: IconSizeTokens.XL,
                align: IconAlignmentTokens.left,
            },
        },
        {
            id: '4',
            title: 'Refer & Earn',
            status: BottomTabStateToken.NOT_SELECTED,
            icon: {
                name: IconTokens.GiftOutline,
                size: IconSizeTokens.XL,
                align: IconAlignmentTokens.left,
            },
        },
    ],
};
export const argTypes = {
    active: {
        control: 'select',
        options: [
            ...Object.values(BottomTabStateToken),
        ],
    },
    onPress: { action: 'clicked' },
};
